import { clsx } from "clsx";
import { type VFC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import styleLayout from "../core/styles/PageLayout.module.scss";

import { type ISystemAdminState, loadSystemDetails } from "../../redux/modules/system-admin.js";
import { type IAppState } from "../../redux/reducer.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";
import SystemInformationCard from "../entities/cards/SystemInformationCard.js";

interface ISystemDetailsPageOwnProps {
  systemId: string;
}

const SystemDetailsPage: VFC<ISystemDetailsPageOwnProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const systemInfo = useSelector<IAppState, ISystemAdminState>((state) => state.systemAdmin);

  useEffect(() => {
    dispatch(loadSystemDetails(props.systemId));
  }, [dispatch, props.systemId]);

  return (
    <div className={clsx(styleLayout.page, styleLayout.page_scrollable)} style={{ background: "white" }}>
      <div className={styleLayout.page_container}>
        <SystemInformationCard systemInfo={systemInfo} systemId={props.systemId} />
      </div>
    </div>
  );
};

export default SystemDetailsPage;
